import { useLocation } from "react-router-dom";

const useFocusTrapIn = () => {
  const { pathname: route } = useLocation();
  return !(route === "/" || route === "/404");
};

export default useFocusTrapIn;
